import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filter: '',
            myTrainings: false,
            showNoTrainings: false,
            useProfilePictures: false,
            showUserTrainingTypeOnTraining: false,
            showAddKeyForTraining: false,
            usersCanReserveTrainingWithScanQr: false,
            shouldApproveReservedTraining: false,
            userDoNotHavePermissionToReserve: false,
            enableShowOnlyFreeSlot: CONFIG_COMPANY.SHOW_ONLY_FREE_SLOTS,
            showOnlyFreeSlot: false,
            restOfTraining: 0,
            isDebtor: false,
            paymentStyle: '',
            showMyTrainings: false,
            showSeeTrainings: false,
            showSeeTrainingsType: '',
            showSeeTrainingsStartAt: '',
            choosedDate: null,
            formatedChoosedDate: null,
            role: '',
            username: '',
            slotLoading: false,
            currentPosition: 0,
            sortByTime: CONFIG_COMPANY.SORT_TRAININGS_BY_TIME,
            showTotalTermins: CONFIG_COMPANY.SHOW_TOTAL_TERMINS,
            showFilterForTrainings: CONFIG_COMPANY.SHOW_VIEW_FILTER_FOR_TRAININGS != null ? CONFIG_COMPANY.SHOW_VIEW_FILTER_FOR_TRAININGS : false,
            showTrainerOnTrainingPage: CONFIG_COMPANY.SHOW_TRAINER_ON_TRAININGS_PAGE != null ? CONFIG_COMPANY.SHOW_TRAINER_ON_TRAININGS_PAGE : false,
            hiddenColumns: CONFIG_COMPANY.HIDDEN_COLUMNS_TRAINING_TABLE != null ? CONFIG_COMPANY.HIDDEN_COLUMNS_TRAINING_TABLE : "",
            currentDate: '',
            listDates: [],
            slots: [],
            trainingTypes: [],
            selectedTrainingTypes: [],
            trainings: [],
            visibleDays: 0,
            shouldShowMembers: false,
            key: '',
            slotFilter: '-1',
            showDialogApp: false,
            showImagePreview: false,
            showWaitingListData: false,
            listToPreview: [],
            slotToPreview: null,
            imageToPreviewUserId: 0,
            showRestTrainings: true,
            imageToPreview: "",
            loyaltyProgramsEnabled: false,
            loyaltyPrograms: null,
            loyaltyProgramsList: [],
            maxLoyaltyProgram: 0,
            dynamicColors: {},
            trainerSeeOnlyOwnSlots: CONFIG_COMPANY.TRAINER_SEE_ONLY_OWN_SLOTS,
            enableFilterTrainerOnlySlotWithOwnClients: CONFIG_COMPANY.FILTER_TRAINER_ONLY_SLOT_WITH_OWN_CLIENTS,
            trainerMap: new Map(),
            hours: Array.from({ length: 18 }, (_, i) => i + 6), // 6:00 - 19:00
            trainers: [],
            partners: [],
            updatingTrainerSlotId: null,
            filterView: CONFIG_COMPANY.SHOW_VIEW_FILTER_FOR_TRAININGS != null ? 'table' : 'classic',
            selectedSlot: null,
            chooseUser: false,
        }
    },
    computed: {
        filteredTrainings() {
            return this.trainings.filter(item => {
                if (this.myTrainings) {
                    let username = localStorage.getItem('USERNAME');
                    return (item.username === username) && (item.firstName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.lastName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.startAt.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.date.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        item.key.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                        (item.firstName + ' ' + item.lastName).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1)
                }
                return item.firstName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.lastName.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.startAt.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.date.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    item.key.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 ||
                    (item.firstName + ' ' + item.lastName).toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1
            }).filter(item2 => {
                if(this.slotFilter === '-1') return true
                if(this.slotFilter === '-2') return item2.trainingType === "_QR_CODE_TRAINING"
                return this.slotFilter === item2.slotId
            }).filter(item3 => {
                if(this.selectedTrainingTypes.length === 0) return true;
                return this.selectedTrainingTypes.includes(item3.trainingType);
            }).filter(item4 =>{
                var traininerName = session.getPersonalTrainer()
                if(traininerName == null) return true;
                if(traininerName === 'null') return true;
                if(traininerName === '') return true;
                return item4.trainerOnSlot === traininerName || item4.paymentCompany === traininerName;
            }).sort((a,b) => this.compareByTime(a,b))
        },
        filteredSlots(){
            let slots = this.slots.filter(item4 => {
                if(this.trainerSeeOnlyOwnSlots === true && this.role === 'ROLE_TRAINER'){
                    return item4.trainerOnSlot === session.getPersonalTrainer()
                }else if(this.enableFilterTrainerOnlySlotWithOwnClients === true && this.role === 'ROLE_TRAINER'){
                    return this.trainerMap.has(item4.id)
                }else{
                    return true
                }
            }).filter(item3 => {
                if(this.showOnlyFreeSlot){
                    return item3.trainingCount > 0
                }else{
                    return true
                }
            });
            if(this.selectedTrainingTypes.length === 0) return slots;
            return slots.filter(item => {
                return this.selectedTrainingTypes.includes(item.trainingType);
            })
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
    },
    methods: {
        closeMyTrainingsHandler() {
            this.showMyTrainings = false;
        },
        closeDeleteWaitingListHandler() {
            this.showWaitingListData = false;
            this.listToPreview = [];
        },
        successDeleteWaitingListHandler() {
            this.showWaitingListData = false;
            this.listToPreview = [];
            this.getSlots(this.currentDate);
        },
        closeSeeTrainingsHandler() {
            this.showSeeTrainings = false;
            this.showSeeTrainingsType = '';
            this.showSeeTrainingsStartAt = '';
        },
        closeShowImageHandler() {
            this.showImagePreview = false;
        },
        closeChooseUserHandler() {
            this.chooseUser = false;
            this.selectedSlot = null;
        },
        onUserSelectedHandler(data) {
            this.chooseUser = false;
            if (this.selectedSlot && this.selectedSlot.id) {
                this.reserveTrainingForUser(this.selectedSlot.id, data.id, data.selectedTrainer);
            } else {
                this.scanQrCodeForUser(data.id);
            }
        },
        initDates: initDates,
        generateDates: generateDates,
        displayDate: displayDate,
        dateLeft: dateLeft,
        getConfig:getConfig,
        dateRight: dateRight,
        getSlots: getSlots,
        approveTraining: approveTraining,
        addTraining: addTraining,
        isTrainerApprove: isTrainerApprove,
        deleteSlot: deleteSlot,
        subscribeToSlot: subscribeToSlot,
        unsubscribeToSlot: unsubscribeToSlot,
        getChipClass: getChipClass,
        getTrainingCountClass: getTrainingCountClass,
        getMonthDisplay: getMonthDisplay,
        isSelected: isSelected,
        onLoadConfig: onLoadConfig,
        reserveTraining: reserveTraining,
        viewTrainings: viewTrainings,
        getTrainings: getTrainings,
        deleteTraining: deleteTraining,
        adminDeleteTraining: adminDeleteTraining,
        loyaltyStyle: loyaltyStyle,
        refresh: refresh,
        setDate: setDate,
        getMe: getMe,
        getTrainingStyleTr: getTrainingStyleTr,
        setCurrentDate: setCurrentDate,
        formatDate: formatDate,
        formatDay: formatDay,
        openUser: openUser,
        isSubscriberToSlot: isSubscriberToSlot,
        getModuleAdminStyle: getModuleAdminStyle,
        getDaySelectedColor: getDaySelectedColor,
        isActiveMemberShip: isActiveMemberShip,
        getStyleByMemberShip: getStyleByMemberShip,
        signUpUserToOpenGym: signUpUserToOpenGym,
        addKey: addKey,
        getTextLengthStyle: getTextLengthStyle,
        addNotArrival: addNotArrival,
        showMyTrainingsFun: showMyTrainingsFun,
        removeNotArrival: removeNotArrival,
        getNotArrivalStyle: getNotArrivalStyle,
        onChangeSlot: onChangeSlot,
        clickTrainingTypes: clickTrainingTypes,
        showSeeTrainingsFun: showSeeTrainingsFun,
        seeWaitingList: seeWaitingList,
        isVisibleSeeWaitingList: isVisibleSeeWaitingList,
        detectAgent:detectAgent,
        getColorForType: getColorForType,
        openImage: openImage,
        showWaitingList: showWaitingList,
        getDynamicColor: getDynamicColor,
        updateTrainingTableData: updateTrainingTableData,
        loadPartners: loadPartners,
        updateTrainerOnSlot: updateTrainerOnSlot,
        isUpdatingTrainerOnSlot: isUpdatingTrainerOnSlot,
        generateExcelFile: generateExcelFile,
        editTraining: editTraining,
        reserveTrainingForUser: reserveTrainingForUser,
        openChooseUser: openChooseUser,
        deleteTrainingAndUsers: deleteTrainingAndUsers,
        changeFilterView: changeFilterView,
        scanQrCodeForUser: scanQrCodeForUser,
        listener(){
            this.getSlots(this.currentDate)
            this.getTrainings();
        },
        compareByTime(a, b) {
            if(this.sortByTime == null) return 0
            let asc = this.sortByTime === "ASC"
            try {
                let aTime = (parseInt(a.startAt.split(":")[0]) * 100) + parseInt(a.startAt.split(":")[1])
                let bTime = (parseInt(b.startAt.split(":")[0]) * 100) + parseInt(b.startAt.split(":")[1])
                if (aTime > bTime)
                    return asc ? 1 : -1;
                if (aTime < bTime)
                    return asc ? -1 : 1;
            }catch (e) {
                return 0;
            }
            return 0;
        },
        getSlotsForHour(slots, hour) {
            return slots.filter((slot) => {
                const slotStart = parseFloat(slot.startAt.replace(":", "."));
                return slotStart >= hour && slotStart < hour + 1;
            });
        },
        getSlotStyle(slot) {
            const [startHour, startMin] = slot.startAt.split(":").map(Number);
            const [endHour, endMin] = [startHour + 1, startMin]//slot.start.split(":").map(Number);

            const top = (startMin / 60) * 100;
            const durationHours = endHour + endMin / 60 - (startHour + startMin / 60);
            const height = durationHours * 100;


            const theme = getCurrentTheme();
            const token = getTypeColorToken(slot.trainingType, theme);
            const borderColor = hexToRgba(token.border, theme === 'light' ? 0.58 : 0.72);
            const bgStart = hexToRgba(token.start, theme === 'light' ? 0.52 : 0.44);
            const bgEnd = hexToRgba(token.end, theme === 'light' ? 0.38 : 0.3);
            const textColor = theme === 'light' ? '#1f315c' : '#eef4ff';
            return {
                top: `${top}%`,
                height: `${height}%`,
                position: "absolute",
                left: "5px",
                right: "5px",
                color: `${textColor}`,
                background: `linear-gradient(135deg, ${bgStart} 0%, ${bgEnd} 100%)`,
                border: `1px solid ${borderColor}`,
                borderRadius: "5px",
                padding: "2px",
                fontSize: "14px"
            };
        },
        openDatePicker() {
            const input = this.$refs.dateInput;
            input.showPicker();
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeMyTrainings', this.closeMyTrainingsHandler);
        this.$topnavbar.$on('closeDeleteWaitingList', this.closeDeleteWaitingListHandler);
        this.$topnavbar.$on('successDeleteWaitingList', this.successDeleteWaitingListHandler);
        this.$topnavbar.$on('closeSeeTrainings', this.closeSeeTrainingsHandler);
        this.$trainingBus.$on('refreshTrainings', this.listener);
        this.$topnavbar.$on('closeShowImage', this.closeShowImageHandler);
        this.$topnavbar.$on('closeChooseUser', this.closeChooseUserHandler);
        this.$topnavbar.$on('onUserSelected', this.onUserSelectedHandler);
        // this.$topnavbar.$on('closeMyTrainings', () => {
        //     _self.showMyTrainings = false;
        // });
        //
        // this.$topnavbar.$on('closeDeleteWaitingList', () => {
        //     _self.showWaitingListData = false;
        //     _self.listToPreview = [];
        // });
        //
        // this.$topnavbar.$on('successDeleteWaitingList', () => {
        //     _self.showWaitingListData = false;
        //     _self.listToPreview = [];
        //     _self.getSlots(_self.currentDate)
        // });
        //
        // this.$topnavbar.$on('closeSeeTrainings', () => {
        //     _self.showSeeTrainings = false;
        //     _self.showSeeTrainingsType = '';
        //     _self.showSeeTrainingsStartAt = '';
        // });
        //
        // this.$trainingBus.$on('refreshTrainings', this.listener);
        //
        // this.$topnavbar.$on('closeShowImage', () => {
        //     _self.showImagePreview = false;
        // });
        //
        // this.$topnavbar.$on('closeChooseUser', () => {
        //     _self.chooseUser = false;
        //     _self.selectedSlot = null;
        // });
        //
        // this.$topnavbar.$on('onUserSelected', (data) => {
        //     _self.chooseUser = false;
        //     if(_self.selectedSlot != null && _self.selectedSlot.id != null){
        //         _self.reserveTrainingForUser(_self.selectedSlot.id, data.id, data.selectedTrainer)
        //     }else{
        //         _self.scanQrCodeForUser(data.id)
        //     }
        // });
    },

    beforeDestroy() {
        this.$topnavbar.$off('closeMyTrainings', this.closeMyTrainingsHandler);
        this.$topnavbar.$off('closeDeleteWaitingList', this.closeDeleteWaitingListHandler);
        this.$topnavbar.$off('successDeleteWaitingList', this.successDeleteWaitingListHandler);
        this.$topnavbar.$off('closeSeeTrainings', this.closeSeeTrainingsHandler);
        this.$trainingBus.$off('refreshTrainings', this.listener);
        this.$topnavbar.$off('closeShowImage', this.closeShowImageHandler);
        this.$topnavbar.$off('closeChooseUser', this.closeChooseUserHandler);
        this.$topnavbar.$off('onUserSelected', this.onUserSelectedHandler);
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

        this.role = session.getRole();
        this.username = session.getUsername();
        this.getConfig()
        if (this.role === 'ROLE_ADMIN' || this.role === 'ROLE_SUPER_ADMIN' || this.role === 'ROLE_TRAINER') {
            this.loadPartners();
        }
        this.getMe();
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures
        this.showRestTrainings = session.getConfig().showRestTrainings == null ? true : session.getConfig().showRestTrainings
        if(this.role === 'ROLE_USER'){
            this.userDoNotHavePermissionToReserve = session.getConfig().userDoNotHavePermissionToReserve == null ? true : session.getConfig().userDoNotHavePermissionToReserve
        }
        this.shouldApproveReservedTraining = session.getConfig().shouldApproveReservedTraining == null ? false : session.getConfig().shouldApproveReservedTraining
        this.showUserTrainingTypeOnTraining = CONFIG_COMPANY.SHOW_USER_TRAINING_TYPE_ON_TRAINING;
        this.showAddKeyForTraining = CONFIG_COMPANY.ADD_KEY_FOR_TRAINING;

        this.loyaltyProgramsEnabled = session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0;
        this.loyaltyPrograms = session.getConfig().loyaltyPrograms;
        this.dynamicColors = session.getAppColors();
        this.usersCanReserveTrainingWithScanQr = session.getConfig().usersCanReserveTrainingWithScanQr != null && session.getConfig().usersCanReserveTrainingWithScanQr !== ""
        if(session.getConfig().loyaltyPrograms != null && session.getConfig().loyaltyPrograms.length > 0){
            let temp = this.loyaltyPrograms.split(";")
            this.loyaltyProgramsList = [];
            temp.forEach(t => {
                this.loyaltyProgramsList.push(parseInt(t));
            })
            this.maxLoyaltyProgram = Math.max(...this.loyaltyProgramsList);
        }
        if(session.getFilterView() == null){
            session.saveFilterView(this.filterView)
        }
        this.filterView = session.getFilterView()
    },
    watch: {
        choosedDate: function (val, oldVal){
            if(val != null){
                try{
                    const [year, month, day] = val.split("-");
                    const reformattedDate = `${day}-${month}-${year}`;
                    this.currentDate = reformattedDate;
                    this.formatedChoosedDate = reformattedDate;
                    this.getSlots(this.currentDate)
                    this.getTrainings()
                }catch (e) {

                }
            }else {
                this.formatedChoosedDate = null
            }

        }
    }
    // watch: {
        // 'myTrainings': function (newVal) {
        //     //TODO PROVERITI DA LI OVO TREVBA
        //     // this.getTrainings();
        // },
        // 'slotFilter': function (newVal) {
        //     //TODO PROVERITI DA LI OVO TREVBA
        //     // this.getTrainings();
        // }
    // }
}
function scanQrCodeForUser(userId) {
    let _self = this;
    let model = {
        gymQr: session.getConfig().usersCanReserveTrainingWithScanQr.replace("g_",""),
    };

    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    AdminApiService.adminSignUpUserForTrainingAsScanQrCode(model, userId)
        .then((response) => {
            _self.getTrainings();
            swal(LocService.t("label_success"), LocService.t("label_training_success_reserved"), 'success')
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function signUpUserToOpenGym(){
    this.chooseUser = true;
}

function changeFilterView(){
    this.filterView === 'table' ? this.filterView = 'classic' : this.filterView = 'table'
    session.saveFilterView(this.filterView)
}

function deleteTrainingAndUsers(training) {
    let _self = this;

    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_delete_term")  + ": " + training.date,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText:  LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText:  LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        swal({
            title: LocService.t("label_back_training"),
            text:  LocService.t("label_back_training_are_you_sure"),
            type: 'warning',
            showCancelButton: true,
            cancelButtonText: LocService.t("label_no"),
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: LocService.t("label_yes"),
            customClass: 'swal2-warning'
        }).then(function () {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {});
            AdminApiService.deleteSlotAndUsers(training.id, true)
                .then((response) => {
                    swal(LocService.t("label_success"), LocService.t("label_term_deleted"), 'success')
                    _self.getSlots(_self.currentDate)
                    _self.getTrainings()
                })
                .catch((error) => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        }).catch(function () {
            swal({
                title: "",
                text: "",
                type: "",
                // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
                html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                customClass: 'swal-custom'
            }, function (selection) {});
            AdminApiService.deleteSlotAndUsers(training.id, false)
                .then((response) => {
                    swal(LocService.t("label_success"), LocService.t("label_term_deleted"), 'success')
                    _self.getSlots(_self.currentDate)
                    _self.getTrainings()
                })
                .catch((error) => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        });


    });
}

function reserveTrainingForUser(slotId, mUserid, selectedTrainer){
    let _self = this;
    let model = {
        slotId: slotId,
        trainer: selectedTrainer
    }
    AdminApiService.addTrainingFromAdmin(model, mUserid)
        .then((response) => {
            _self.selectedSlot = null;
            _self.getSlots(_self.currentDate)
            _self.getTrainings()
            swal(LocService.t("label_success"), LocService.t("label_success_add_training"), 'success')
        })
        .catch((error) => {
            _self.selectedSlot = null;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')

        })
}

function openChooseUser(slot){
    this.selectedSlot = slot
    this.chooseUser = true;
}

function editTraining(training) {
    this.$router.push('edit-training?id=' + training.id)
}

function loadPartners() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function isUpdatingTrainerOnSlot(slot) {
    return this.updatingTrainerSlotId === slot.id;
}

function updateTrainerOnSlot(slot) {
    let _self = this;
    let model = {
        date: slot.date,
        maxTrainings: slot.maxTrainings,
        startAt: slot.startAt,
        trainingType: slot.trainingType,
        trainerOnSlot: slot.trainerOnSlot
    };
    if (model.trainerOnSlot === '') {
        model.trainerOnSlot = null;
    }
    _self.updatingTrainerSlotId = slot.id;
    AdminApiService.updateSlot(model, slot.id)
        .then(() => {
            _self.updatingTrainerSlotId = null;
            _self.updateTrainingTableData(_self.slots);
        })
        .catch(error => {
            _self.updatingTrainerSlotId = null;
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            _self.getSlots(_self.currentDate);
        })
}

function showWaitingList(item){
    if(item.rsubscribers == null) return;
    if(item.rsubscribers.length === 0) return;
    let sub = item.rsubscribers.split(",").filter(e=> e.length > 0)
    this.showWaitingListData = true
    this.listToPreview = sub
    this.slotToPreview = item;
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId
    this.showImagePreview = true;
}

function clickTrainingTypes(item){
    if(this.selectedTrainingTypes.includes(item)){
        this.selectedTrainingTypes = this.selectedTrainingTypes.filter(e => e !== item)
    }else{
        this.selectedTrainingTypes.push(item)
    }
}

function showMyTrainingsFun(){
    this.showMyTrainings = true;
}

function showSeeTrainingsFun(slot){
    this.showSeeTrainingsType = slot.trainingType;
    this.showSeeTrainingsStartAt = slot.startAt;
    this.showSeeTrainings = true;
}

function isTrainerApprove(){
    return this.role === 'ROLE_TRAINER' && CONFIG_COMPANY.ADD_SLOT_PERMISSION
}

function onLoadConfig(){
    this.initDates(this.$moment, this.listDates)
    this.currentDate = this.listDates[0]
    this.setCurrentDate(this.$route.query.date, this.listDates)
    this.getSlots(this.currentDate)
    this.getTrainings()
    this.detectAgent()
}

function getConfig(){
    if(!session.shouldFetchConfig()) {
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.onLoadConfig()
        return;
    }
    let _self = this;
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.onLoadConfig()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            _self.onLoadConfig()
        })
}

function onChangeSlot(event) {
    this.slotFilter = event.target.value
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function setCurrentDate(date, list) {
    let _self = this;
    for (let i = 0; i < list.length; i++) {
        if (list[i] === date) {
            _self.currentDate = date
            return;
        }
    }
}

function initDates(moement, list) {
    if (session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN' || session.getRole() === 'ROLE_TRAINER') {
        let adminDays = session.getConfig().adminVisibleDays == null ? 7 : session.getConfig().adminVisibleDays
        this.generateDates(adminDays, moement, list)
    } else if (session.getRole() === 'ROLE_USER') {
        let userDays = session.getConfig().userVisibleDays == null ? 3 : session.getConfig().userVisibleDays
        this.generateDates(userDays, moement, list)
    }
}


function generateDates(numOfDates, moment, list) {
    var today = new Date();
    for (var i = 0; i < numOfDates; i++) {
        today = new Date();
        today.setDate(today.getDate() + i);
        list.push(moment(today).format('DD-MM-YYYY'))
    }
}

function setDate(date) {
    this.currentDate = date
    this.choosedDate = null
    this.getSlots(this.currentDate)
    this.getTrainings()
}

function dateLeft() {
    if (this.currentPosition !== 0) {
        this.currentPosition -= 1;
        this.currentDate = this.listDates[this.currentPosition];
        this.getSlots(this.currentDate)
        this.getTrainings()
    }
}

function dateRight() {
    // let size = _self.listDates.length - 1;
    if (this.currentPosition < this.listDates.length - 1) {
        this.currentPosition += 1;
        this.currentDate = this.listDates[this.currentPosition];
        this.getSlots(this.currentDate)
        this.getTrainings()
    }
}

function getSlots(date) {
    let _self = this;
    this.slotLoading = true
    AdminApiService.getSlotByDate(date)
        .then((response) => {
            _self.updateTrainingTableData(response.data)
            var myTrainingTypes = new Set();
            response.data.forEach(e => {
                myTrainingTypes.add(e.trainingType)
            })
            _self.trainingTypes = myTrainingTypes
            _self.selectedTrainingTypes = _self.selectedTrainingTypes.filter(e => myTrainingTypes.has(e))
            console.log(_self.selectedTrainingTypes)
            _self.slots = response.data;
            _self.slotLoading = false
            _self.showNoTrainings = response.data.length === 0
        })
        .catch(error => {
            console.log(error)
            this.slotLoading = false
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function updateTrainingTableData(slots){
    let trainerMap = new Map();
    let typeMap = new Map();
    let noTrainerLabel = LocService.t("label_no_trainer");
    for(var i = 0; i < slots.length; i++){
        let trainerOnSlot = slots[i].trainerOnSlot != null && slots[i].trainerOnSlot.length > 0 ? slots[i].trainerOnSlot : noTrainerLabel
        let trainingType = slots[i].trainingType != null ? slots[i].trainingType : LocService.t("label_no_type")
        if(!trainerMap.has(trainerOnSlot)){
            trainerMap.set(trainerOnSlot, [])
        }
        if(!typeMap.has(trainingType)){
            typeMap.set(trainingType, [])
        }
        trainerMap.get(trainerOnSlot).push(slots[i])
        typeMap.get(trainingType).push(slots[i])
    }

    let result = [];

    console.log("NO TRAINER 1");
    console.log(trainerMap.get(noTrainerLabel) != null);

    if(trainerMap.size === 1 && trainerMap.get(noTrainerLabel) != null){
        for (let [key, value] of typeMap.entries()) {
            result.push({
                id: key,
                name: key,
                slots: value,
                sortByTrainingType: true
            });
        }
        this.trainers = sortTrainingTableColumns(result, noTrainerLabel);
        return;
    }
    for (let [key, value] of trainerMap.entries()) {
        result.push({
            id: key,
            name: key,
            slots: value,
            sortByTrainingType: false
        });
    }

    this.trainers = sortTrainingTableColumns(result, noTrainerLabel)
}

function sortTrainingTableColumns(items, noTrainerLabel) {
    return items.sort((a, b) => {
        if (a.name === noTrainerLabel) return 1;
        if (b.name === noTrainerLabel) return -1;
        return a.name.localeCompare(b.name);
    });
}

function addTraining() {
    this.$router.push('/add-training?date=' + this.currentDate)
}

function viewTrainings() {
    this.$router.push('/view-trainings?date=' + this.currentDate)
}

function deleteSlot(slot) {
    // alert(slot.id)
}

function getTrainings() {
    let _self = this;
    this.showNoTrainings = false
    AdminApiService.getTrainingsByDate(this.currentDate)
        .then((response) => {
            this.trainings = response.data
            let mySlots = new Map();
            console.log(_self.enableFilterTrainerOnlySlotWithOwnClients === true)
            if(_self.enableFilterTrainerOnlySlotWithOwnClients === true && this.role === 'ROLE_TRAINER'){
                console.log("OVDE SAM")
                for(var i = 0; i< response.data.length; i++){
                    console.log(response.data[i].paymentCompany)
                    if(response.data[i].paymentCompany === session.getPersonalTrainer()){
                        mySlots.set(response.data[i].slotId, response.data[i].slotId)
                    }
                }
            }
            _self.trainerMap = mySlots;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reserveTraining(slot) {
    let _self = this;
    let model = {
        slotId: slot.id
    };
    this.$topnavbar.$emit('load');
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.addTraining(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success_add_training"), 'success')
            _self.getSlots(this.currentDate)
            _self.getTrainings()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function deleteTraining(item) {
    if (this.role === 'ROLE_ADMIN' || this.role === 'ROLE_SUPER_ADMIN' || this.role === 'ROLE_TRAINER') {
        adminDeleteTraining(item, this);
        return;
    }
    let _self = this;
    this.$topnavbar.$emit('cancelTrainings');
    AdminApiService.deleteTraining(item.id)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success_remove_training"), 'success')
            _self.getSlots(this.currentDate)
            _self.getTrainings()
            _self.$topnavbar.$emit('newTrainings')
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getStyleByMemberShip(training){
    if(!this.isActiveMemberShip(training) || training.debtor){
        return 'notActiveMember'
    }else{
        return '';
    }
}

function isActiveMemberShip(training){
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const currentTimeInMilliseconds = currentDate.getTime();
    if(currentTimeInMilliseconds > (training.expireDate * 1000 + 10800000)){
        return false;
    }else{
        return true;
    }
}

function adminDeleteTraining(item, app) {
    let _self = app;
    swal({
        title: LocService.t("label_back_training"),
        text:  LocService.t("label_back_training_are_you_sure"),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('cancelTrainings');
        AdminApiService.deleteTrainingAndRevertToUser(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_success_remove_training"), 'success')
                _self.refresh()
                _self.$topnavbar.$emit('newTrainings')
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    }).catch(function () {
        _self.$topnavbar.$emit('cancelTrainings');
        AdminApiService.deleteTraining(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t("label_success_remove_training"), 'success')
                _self.refresh()
                _self.$topnavbar.$emit('newTrainings')
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function refresh() {
    this.getSlots(this.currentDate)
    this.getTrainings()
}

function getTrainingStyleTr(training) {
    if (this.role === 'ROLE_USER') return "color: white;";
    if (training.restOfTrainings < 4 && (this.role === 'ROLE_ADMIN' || this.role === 'ROLE_SUPER_ADMIN' || this.role === 'ROLE_TRAINER')) {
        return "color: orange;"
    }
    let userDate = new Date(this.formatDate(training.expireDate) + 'T00:00:00');
    let currentDate = new Date(this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00');
    if ((userDate.getTime() - currentDate.getTime()) < 259200000) {
        return "color: orange;"
    }
    if (training.debtor && (this.role === 'ROLE_ADMIN' || this.role === 'ROLE_SUPER_ADMIN' || this.role === 'ROLE_TRAINER')) {
        return "color: red;"
    } else {
        return "color: white;"
    }
}

function addKey(id, key) {
    let _self = this
    swal({
        title: LocService.t("label_set_key"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" placeholder="'+ LocService.t("label_set_key") +'" class="input" style="width: 50%; border-radius: 10px" value="'+ key +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var k = document.getElementById('swal-input').value
        var model = {
            trainingId: id,
            key: k
        }
        AdminApiService.addKey(model)
            .then((response) => {
                _self.getTrainings()
            })
            .catch(error => {
                _self.getTrainings()
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}

function addNotArrival(userId) {
    let _self = this;
    AdminApiService.addNotArrival(userId)
        .then((response) => {
            _self.getTrainings()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function removeNotArrival(userId) {
    let _self = this;
    AdminApiService.removeNotArrival(userId)
        .then((response) => {
            _self.getTrainings()
        })
        .catch(error => {

            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('YYYY-MM-DD')
}

function displayDate(d){
    if(this.isMobile){
        let date = d.substring(0,5);
        var temp = date.split("-")
        return temp[0] + "." + this.getMonthDisplay(temp[1])
    }
    return d;
}

function getMonthDisplay(month) {
    switch (month) {
        case '01': return this.locale.t("month_short_january");
        case '02': return this.locale.t("month_short_february");
        case '03': return this.locale.t("month_short_march");
        case '04': return this.locale.t("month_short_april");
        case '05': return this.locale.t("month_short_may");
        case '06': return this.locale.t("month_short_june");
        case '07': return this.locale.t("month_short_july");
        case '08': return this.locale.t("month_short_august");
        case '09': return this.locale.t("month_short_september");
        case '10': return this.locale.t("month_short_october");
        case '11': return this.locale.t("month_short_november");
        case '12': return this.locale.t("month_short_december");
        default: return this.locale.t("month_short_january");
    }
}

function formatDay(stringDate, fullName){
    let dates = stringDate.split('-')
    let date = dates[2] +"-" + dates[1] + "-" + dates[0]+"T00:00:00"
    let day = this.$moment(new Date(date)).isoWeekday()
    var d = ""
    switch (day) {
        case 1 : d = this.locale.t("day_monday"); break;
        case 2 : d =  this.locale.t("day_tuesday"); break;
        case 3 : d =  this.locale.t("day_wednesday"); break;
        case 4 : d =  this.locale.t("day_thursday"); break;
        case 5 : d =  this.locale.t("day_friday"); break;
        case 6 : d =  this.locale.t("day_saturday"); break;
        case 7 : d =  this.locale.t("day_sunday"); break;
    }
    if(this.isMobile && !fullName){
        return d.substring(0,3).toUpperCase()
    }
    return d;
}

function getNotArrivalStyle(notArrival) {
    if(notArrival <= 0){
        return ""
    }else if(notArrival === 1){
       return "background: purple;"
    }else{
        return "background: red;"
    }
}

function getDaySelectedColor(date) {
    if(date === this.currentDate){
        return "color: orange;"
    }else {
        return "color: white;"
    }
}

function getModuleAdminStyle(date) {
    if(date === this.currentDate){
        return "border-color: orange;"
    }else {
        return "border-color: lawngreen;"
    }
}

function openUser(training){
    if(session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN'){
        this.$router.push('/edit-user?id=' + training.userId);
    }

}

function getChipClass(item){
    if(this.selectedTrainingTypes.includes(item)){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedTrainingTypes.includes(item)
}

function getColorForType(type) {
    const theme = getCurrentTheme();
    const token = getTypeColorToken(type, theme);
    const borderColor = hexToRgba(token.border, theme === 'light' ? 0.58 : 0.72);
    const bgStart = hexToRgba(token.start, theme === 'light' ? 0.52 : 0.44);
    const bgEnd = hexToRgba(token.end, theme === 'light' ? 0.38 : 0.3);
    return 'background: linear-gradient(135deg, ' + bgStart + ' 0%, ' + bgEnd + ' 100%);' +
        ' border: 1px solid ' + borderColor + ';';
}

function getCurrentTheme() {
    if (typeof document === 'undefined' || document.body == null) return 'dark';
    if (document.body.classList.contains('theme-light')) return 'light';
    return 'dark';
}

function getTypeColorToken(type, theme) {
    const palette = theme === 'light' ? TRAINING_SLOT_PALETTE_LIGHT : TRAINING_SLOT_PALETTE_DARK;
    const key = String(type == null ? '' : type).trim().toLowerCase();
    const hash = hashString(key.length > 0 ? key : 'default');
    const index = Math.abs(hash) % palette.length;
    return palette[index];
}

function hashString(text) {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash |= 0;
    }
    return hash;
}

function hexToRgba(hexColor, alpha) {
    const hex = normalizeHex(hexColor).replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}

function normalizeHex(color) {
    const value = String(color || '').trim().replace('#', '');
    if (value.length === 3) {
        return '#' + value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
    }
    if (value.length === 6) {
        return '#' + value;
    }
    return '#7890c0';
}

const TRAINING_SLOT_PALETTE_DARK = [
    { start: '#4d73d1', end: '#3558ad', border: '#6f91ea' },
    { start: '#45a8a2', end: '#2f837e', border: '#63c4bd' },
    { start: '#9a66d8', end: '#7644ba', border: '#b387ea' },
    { start: '#d07b45', end: '#ad5d2c', border: '#e49c6e' },
    { start: '#6ea64f', end: '#4f7f34', border: '#8ecb6d' },
    { start: '#c75f94', end: '#9f4170', border: '#df85b1' },
    { start: '#4f9ac8', end: '#3375a2', border: '#73b8e3' },
    { start: '#c26b58', end: '#994b3a', border: '#dc8f7d' },
    { start: '#7a82d2', end: '#575fb0', border: '#9ba3ef' },
    { start: '#47a67a', end: '#2f825c', border: '#69c79b' }
];

const TRAINING_SLOT_PALETTE_LIGHT = [
    { start: '#cfe0ff', end: '#b9cdf9', border: '#6d8fd8' },
    { start: '#ccefeb', end: '#b6e2dd', border: '#4f9c96' },
    { start: '#e6d6ff', end: '#d7c3fb', border: '#8d67c8' },
    { start: '#ffe1cc', end: '#f8cfb3', border: '#b56f43' },
    { start: '#d9efcc', end: '#c8e3b9', border: '#69984a' },
    { start: '#ffd5e6', end: '#f5bfd8', border: '#b35e89' },
    { start: '#d3ecff', end: '#bfdef7', border: '#4d88b4' },
    { start: '#ffe0d8', end: '#f6c9bc', border: '#b26152' },
    { start: '#dddfff', end: '#cbcffa', border: '#6770c3' },
    { start: '#d2f0e3', end: '#bde4d4', border: '#4b8d6d' }
];


function getMe() {
    let _self = this;
    if(localStorage.getItem('ACCESS_TOKEN') == null) return;
    AdminApiService.getProfile()
        .then((response) => {
            _self.restOfTraining = response.data.restOfTraining
            _self.isDebtor = response.data.debtor;
            let expireDate = this.$moment(new Date(response.data.expireDate * 1000)).format('YYYY-MM-DD') + 'T00:00:00'
            let today = this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00'
            if(expireDate === today){
                this.paymentStyle = "orange;";
            }else if(this.$moment(today).isAfter(expireDate)){
                this.paymentStyle = "red;";
            }else{
                this.paymentStyle = "green;";
            }
        })
        .catch(error => {
            // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingCountClass(){
    if(this.restOfTraining === 0 || this.isDebtor) return 'training-count red'
    if(this.restOfTraining <= 3 || this.paymentStyle === 'orange') return 'training-count orange'
    return 'training-count green';
}

function subscribeToSlot(slot){
    let _self = this;
    let model = {
        slotId: slot.id
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.subscribeToSlot(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success_add_to_waiting_list"), 'success')
            _self.getSlots(_self.currentDate);
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function isSubscriberToSlot(slot){
    return slot.rsubscribers.includes(session.getUsername());
}

function unsubscribeToSlot(slot){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>" + LocService.t('label_please_wait') + "</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    swal({
        title: LocService.t("label_remove_waiting_list"),
        text:  LocService.t("label_remove_waiting_list_are_you_sure") + " ( " + slot.date + " - " + slot.startAt + " )",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            slotId: slot.id
        }
        AdminApiService.unsubscribeToSlot(model)
            .then((response) => {
                _self.getSlots(_self.currentDate);
                swal(LocService.t("label_success"), LocService.t("label_success_remove_to_waiting_list"), 'success')
            })
            .catch(error => {
                // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    })
}

function getTextLengthStyle(text){
    if(text == null) return '';
    if(text.length > 16 && text.length <= 25) return 'font-size: 14px;  '
    if(text.length > 25) return 'font-size: 10px; '
}

function seeWaitingList(item){
    if(item.rsubscribers == null) return;
    if(item.rsubscribers.length === 0) return;
    let sub = item.rsubscribers.split(",").filter(e=> e.length > 0)
    var newList = ""
    var index = 1;
    sub.forEach(e => {
        newList += index +". " + e +"<br>";
        index++;
    })
    swal(LocService.t("label_waiting_list_title"), newList, 'success')
}

function isVisibleSeeWaitingList(){
    return this.role === 'ROLE_ADMIN' || this.role === 'ROLE_SUPER_ADMIN' || this.role === 'ROLE_TRAINER';
}

function loyaltyStyle(maxItem, userPaidMonthsInRow){
    return userPaidMonthsInRow >= maxItem ? 'color: green;' : 'color: red;'
}

function getDynamicColor(itemId){
    const theme = getCurrentTheme();
    if((itemId === 'ti_title' || itemId === 'ti_desc') && theme === 'light'){
        return 'color: #1f315c;';
    }
    if(this.dynamicColors[itemId] != null){
        return 'color: #'+ this.dynamicColors[itemId];
    }
    if((itemId === 'ti_title' || itemId === 'ti_desc') && theme === 'dark'){
        return 'color: #eef4ff;';
    }
    return '';
}

function approveTraining(training, value){
    let _self = this;
    swal({
        title: LocService.t("label_are_you_sure"),
        text:  LocService.t("label_approve_are_you_sure") + " ( " + training.firstName + " - " + training.lastName + " )",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            trainingId: training.id,
            checked: value,
        }
        AdminApiService.approveTraining(model)
            .then((response) => {
                _self.getTrainings();
                swal(LocService.t("label_success"), LocService.t("label_success_approved_training"), 'success')
            })
            .catch(error => {
                // swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    })
}

function generateExcelFile(){
    let _self = this;
    function compare(a, b) {
        let asc = true;
        try {
            let aTime = (parseInt(a.startAt.split(":")[0]) * 100) + parseInt(a.startAt.split(":")[1])
            let bTime = (parseInt(b.startAt.split(":")[0]) * 100) + parseInt(b.startAt.split(":")[1])
            if (aTime > bTime)
                return asc ? 1 : -1;
            if (aTime < bTime)
                return asc ? -1 : 1;
        }catch (e) {
            return 0;
        }
        return 0;
    }
    let trainings = this.filteredTrainings.sort((a,b) => compare(a,b));
    var csvFile = "";

    //DODAVANJE DATUMA
    for(var i = 0; i < trainings.length; i++){
        csvFile = csvFile + trainings[i].firstName + ", " + trainings[i].lastName + ", " + trainings[i].startAt + ", " + trainings[i].date + "\n"
    }

    let title = LocService.t('label_training_report_title');
    let name = LocService.t('label_name');
    let surname = LocService.t('label_surname');
    let start = LocService.t('label_time');
    let date = LocService.t('label_date');
    // Kreiranje HTML sadržaja
    let htmlContent = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid black; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }
            </style>
        </head>
        <body>
            <h2>${title}</h2>
            <table>
                <tr>
                    <th>${name}</th>
                    <th>${surname}</th>
                    <th>${start}</th>
                    <th>${date}</th>
                </tr>`;

    // Dodavanje redova u tabelu
    trainings.forEach(t => {
        htmlContent += `
                <tr>
                    <td>${t.firstName}</td>
                    <td>${t.lastName}</td>
                    <td>${t.startAt}</td>
                    <td>${t.date}</td>
                </tr>`;
    });

    htmlContent += `
            </table>
        </body>
        </html>`;

    // Otvaranje u novom tabu
    let newWindow = window.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();

    // var universalBOM = "\uFEFF";
    // var link = document.createElement("a");
    // link.setAttribute("href", 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvFile));
    // link.setAttribute("download", "izvestaj.csv");
    // document.body.appendChild(link); // Required for FF
    // link.click(); // This will download the data file nam
}



// WEBPACK FOOTER //
// ./src/components/Trainings/Trainings.js